exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-size-cust[data-v-5c49d6e8]{font-size:1.5rem}", ""]);

// exports
